module.exports = __webpack_public_path__ + "static/media/dynamic_html.ecaf3bc1.jpg";